The input parameter for the `jobCategories` query.
